import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { getCoinDetail } from "../../../actions/getCoinDetail";
//Styles and Icons
import styles from "./DescCoin.module.scss";
import banner1 from "../../../styles/pics/banner1.jpeg";
import { useEffect } from "react";
export default function DescCoin() {
  const { name } = useParams();
  const dispatch = useDispatch();
  const COIN = useSelector((state) => state.coinInfo.data);
  useEffect(() => {
    if (!COIN) dispatch(getCoinDetail(name));
  }, [name]);
  return (
    <div className={styles.container}>
      <div className={styles.coin_img}>
        <img src={banner1} alt="" width={320} height={165} />
      </div>
      <div className={styles.chart_buttons_coin}>
        <Link to="/">
          <div
            className={`${styles.button_chart_coin} ${styles.technical_chart}`}
          >
            نمودار تکنیکال
          </div>
        </Link>
        <Link to="/">
          <div className={`${styles.button_chart_coin} ${styles.price_chart}`}>
            نمودار قیمت
          </div>
        </Link>
      </div>
      <div className={`font_color_white ${styles.coin_description}`}>
        <div dangerouslySetInnerHTML={{ __html: COIN?.description }} />
      </div>
    </div>
  );
}
